var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popstyle2", staticStyle: { padding: "0 12px" } },
    [
      _c(
        "b-modal",
        {
          ref: "usersManagementModal",
          staticStyle: { "margin-top": "0" },
          attrs: {
            id: "users-management-modal",
            size: "lg",
            title: _vm.modalTitle,
            centered: "",
            "hide-footer": true,
            disabled: "true"
          },
          on: { hidden: _vm.onHidden }
        },
        [_c("CierreLotesList", { attrs: { permisos: _vm.permisos } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/cierre-lotes-management/CierreLotesManagement.vue?vue&type=template&id=b26831a6&scoped=true&
// module id = null
// module chunks = 